import EmptyBoxIcon from './EmptyBoxIcon'

export default EmptyBoxIcon
